(() => {
  if (window.KDKFrameInfoGallery && typeof window.KDKFrameInfoGallery.init === 'function') {
    window.KDKFrameInfoGallery.init(document);
    return;
  }

  const instances = new Map();

  function keyFromValue(value) {
  return String(value || '')
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\u00A0/g, ' ')
    .replace(/&/g, '_')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}


  function canonicalFrameKeys(value) {
    const raw = keyFromValue(value);
    const tokens = raw.split('_').filter(Boolean);
    const has = (values) => values.some((item) => tokens.includes(item));

    let family = '';
    if (has(['minimal'])) family = 'minimal';
    else if (has(['century'])) family = 'century';
    else if (has(['gallery', 'galery', 'galeri', 'lienzo'])) family = 'gallery';

    let color = '';
    if (has(['negro', 'black', 'noir', 'schwarz', 'preto'])) color = 'negro';
    else if (has(['blanco', 'white', 'blanc', 'weiss', 'wei', 'branco'])) color = 'blanco';
    else if (has(['nogal', 'walnut', 'noyer', 'walnuss', 'nogueira'])) color = 'nogal';
    else if (has(['madera', 'roble', 'wood', 'oak', 'bois', 'chene', 'eiche', 'holz', 'madeira', 'carvalho'])) color = 'roble';

    const keys = [raw];
    if (family && color) {
      keys.push(`${family}_marco_${color}`);
      if (color === 'roble') keys.push(`${family}_marco_madera`);
    }
    return [...new Set(keys.filter(Boolean))];
  }

  function parseJson(root) {
    const source = root.querySelector('[data-kdk-frame-info-data]');
    if (!source) return [];

    try {
      const payload = JSON.parse(source.textContent || '[]');
      return Array.isArray(payload) ? payload : [];
    } catch (error) {
      console.error('[KDK frame info] JSON inválido', error);
      return [];
    }
  }

  class FrameInfoGallery {
    constructor(root) {
      this.root = root;
      this.formRoot = root.closest('.ProductForm__Variants') || document;
      this.infoBox = root.querySelector('[data-kdk-frame-info]');
      this.heading = root.querySelector('[data-kdk-frame-heading-text]');
      this.thumbList = root.querySelector('[data-kdk-frame-thumb-list]');
      this.modal = root.querySelector('[data-kdk-frame-modal]');
      this.closeButton = root.querySelector('[data-kdk-frame-modal-close]');
      this.slideList = root.querySelector('[data-kdk-frame-slide-list]');
      this.modalThumbList = root.querySelector('[data-kdk-frame-modal-thumb-list]');
      this.caption = root.querySelector('[data-kdk-frame-caption]');
      this.prevButton = root.querySelector('[data-kdk-frame-prev]');
      this.nextButton = root.querySelector('[data-kdk-frame-next]');
      this.items = parseJson(root)
        .map((item) => ({
          ...item,
          __key: keyFromValue(item.key),
          __aliases: Array.isArray(item.aliases)
            ? item.aliases.map(keyFromValue).filter(Boolean)
            : [],
          images: Array.isArray(item.images)
            ? item.images.filter((image) => image && (image.full || image.thumb))
            : []
        }))
        .filter((item) => item.__key && item.images.length);
      this.map = new Map();
      this.items.forEach((item) => {
        [item.__key, ...item.__aliases].forEach((key) => {
          if (key) this.map.set(key, item);
        });
      });
      this.currentItem = null;
      this.currentSlide = 0;
      this.boundChange = this.onChange.bind(this);
      this.boundKeydown = this.onKeydown.bind(this);

      if (!this.infoBox || !this.modal || !this.items.length) {
        this.hideInfo();
        return;
      }

      this.modal.style.display = 'none';
      this.bindEvents();
      this.syncFromForm();
    }

    bindEvents() {
      this.formRoot.addEventListener('change', this.boundChange);
      this.closeButton?.addEventListener('click', () => this.closeModal());
      this.prevButton?.addEventListener('click', () => this.showSlide(this.currentSlide - 1));
      this.nextButton?.addEventListener('click', () => this.showSlide(this.currentSlide + 1));
      document.addEventListener('keydown', this.boundKeydown);
    }

    destroy() {
      this.formRoot.removeEventListener('change', this.boundChange);
      document.removeEventListener('keydown', this.boundKeydown);
    }

    onChange(event) {
      const input = event.target.closest('input[type="radio"][data-option-position="1"]');
      if (!input) return;
      this.render(input.value);
    }

    onKeydown(event) {
      if (this.modal.style.display !== 'block') return;

      if (event.key === 'Escape') {
        this.closeModal();
      } else if (event.key === 'ArrowLeft') {
        this.showSlide(this.currentSlide - 1);
      } else if (event.key === 'ArrowRight') {
        this.showSlide(this.currentSlide + 1);
      }
    }

    syncFromForm() {
      const checked = this.formRoot.querySelector('input[type="radio"][data-option-position="1"]:checked');
      if (checked) {
        this.render(checked.value);
      } else {
        this.hideInfo();
      }
    }

    hideInfo() {
      if (this.infoBox) {
        this.infoBox.style.display = 'none';
        this.infoBox.hidden = true;
      }
    }

    render(frameValue) {
      const item = canonicalFrameKeys(frameValue)
        .map((key) => this.map.get(key))
        .find(Boolean);
      this.currentItem = item || null;

      if (!item) {
        this.hideInfo();
        this.closeModal();
        return;
      }

      this.heading.innerHTML = item.heading || '';
      this.caption.innerHTML = item.caption || '';
      this.thumbList.innerHTML = '';

      item.images.forEach((image, index) => {
        const column = document.createElement('div');
        column.className = 'column';

        const img = document.createElement('img');
        img.src = image.thumb || image.full || '';
        img.alt = image.alt || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.style.width = '100%';
        img.className = 'hover-shadow cursor-2';
        img.addEventListener('click', () => this.openModal(index));

        column.appendChild(img);
        this.thumbList.appendChild(column);
      });

      this.infoBox.hidden = false;
      this.infoBox.style.display = 'block';
    }

    buildModal() {
      if (!this.currentItem) return;

      this.slideList.innerHTML = '';
      this.modalThumbList.innerHTML = '';

      this.currentItem.images.forEach((image, index) => {
        const slide = document.createElement('div');
        slide.className = 'mySlides';

        const number = document.createElement('div');
        number.className = 'numbertext';
        number.textContent = `${index + 1} / ${this.currentItem.images.length}`;

        const img = document.createElement('img');
        img.src = image.full || image.thumb || '';
        img.alt = image.alt || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.style.width = '100%';

        slide.appendChild(number);
        slide.appendChild(img);
        this.slideList.appendChild(slide);

        const thumbColumn = document.createElement('div');
        thumbColumn.className = 'column';

        const thumb = document.createElement('img');
        thumb.className = 'demo cursor';
        thumb.src = image.thumb || image.full || '';
        thumb.alt = image.alt || '';
        thumb.loading = 'lazy';
        thumb.decoding = 'async';
        thumb.style.width = '100%';
        thumb.addEventListener('click', () => this.showSlide(index));

        thumbColumn.appendChild(thumb);
        this.modalThumbList.appendChild(thumbColumn);
      });
    }

    openModal(index) {
      if (!this.currentItem) return;
      this.buildModal();
      this.modal.style.display = 'block';
      this.showSlide(index);
    }

    closeModal() {
      this.modal.style.display = 'none';
    }

    showSlide(index) {
      if (!this.currentItem || !this.currentItem.images.length) return;

      const slides = Array.from(this.slideList.querySelectorAll('.mySlides'));
      const thumbs = Array.from(this.modalThumbList.querySelectorAll('.demo'));
      if (!slides.length) return;

      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      this.currentSlide = index;

      slides.forEach((slide, slideIndex) => {
        slide.style.display = slideIndex === index ? 'block' : 'none';
      });

      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('active', thumbIndex === index);
      });
    }
  }

  function getRoots(scope) {
    if (!scope) return [];
    if (scope.matches?.('[data-kdk-frame-info-gallery]')) return [scope];
    return Array.from(scope.querySelectorAll?.('[data-kdk-frame-info-gallery]') || []);
  }

  function init(scope = document) {
    getRoots(scope).forEach((root) => {
      const key = root.id || root.dataset.kdkFrameInfoGallery || `kdk-frame-${instances.size + 1}`;
      const existing = instances.get(key);
      if (existing) existing.destroy();
      instances.set(key, new FrameInfoGallery(root));
    });
  }

  function destroy(scope = document) {
    getRoots(scope).forEach((root) => {
      const key = root.id || root.dataset.kdkFrameInfoGallery;
      const instance = instances.get(key);
      if (!instance) return;
      instance.destroy();
      instances.delete(key);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));

  window.KDKFrameInfoGallery = {
    init,
    destroy,
    instances
  };
})();
